import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import {List} from '@/components/core';
import mock from '../../_data/join'
import { useForm } from 'react-hook-form';


const noData = [{title: '暂无此岗位', itemClass: 'flex-row justify-center al-item-center'}]

let listInst, tabInst
let searchData = []
const typeListData = [
  { title: '产品', type: 'product' },
  { title: '技术', type: 'technology', },
  { title: '数字评估', type: 'assessment', },
  { title: '风控', type: 'riskcontrol', },
  { title: 'AI', type: 'ai', },
  { title: '财税', type: 'tax', },
]

const adapterType = (data) => {
  let output = []
  data.map((item, ii) => {
    output.push({
      title: item.title,
      itemClass: 'item',
      onClick(e, params, inst) {
        const data = searchData.length > 0 ? searchData : mock
        const res = data.filter(it => it.positionTypeCode === item.type)
        listInst.update(res.length > 0 ? adapter(res) : [])
        inst.siblings().removeClass('active')
        inst.addClass('active')
        // setType(item.type)
      }
    })
  })
  output.unshift({
    title: '全部',
    itemClass: 'item active',
    onClick(e, params, inst) {
      const data = searchData.length > 0 ? searchData : mock
      listInst.update(adapter(data))
      inst.siblings().removeClass('active')
      inst.addClass('active')
      // setType(item.type)
    }
  })
  return output
}
const searchTypeListCfg = {
  data: adapterType(typeListData),
  header: '职位类型：',
  listClass: 'list-screening',
  ready() {
    tabInst = this
  }
}
const adapter = (data) => {
  return data.map(item => {
    return {
      title: {title: item.title, itemClass: 'item-title'},
      body: [
        { title: item.address },
        { title: item.positionTypeName },
      ],
      dot: [{ title: <pre>{item.duties}</pre>, itemClass: 'item-content textellipsis-auto-2'}],
      bodyClass: 'item-type',
      url: '/join?id='+item.id
    }
  })
}
const ListCfg = {
  data: mock.length > 0 ? adapter(mock) : [],
  listClass: 'pages-join',
  ready() {
    listInst = this
  }
}

const SearchForm = (props) =>{
  const [isIcon, setIsIcon] = React.useState(false);
  const {
    register,
    handleSubmit,
    reset,
    getValues,
    setValue
  } = useForm();
  const onSubmit = (res, e) => {
    e.preventDefault()
    const { search } = res
    const data = mock.filter(it => it.title.indexOf(search.trim()) > -1)
    searchData = data
    tabInst.update(adapterType(typeListData))
    listInst.update(data.length > 0 ? adapter(data) : noData)
    if(data.length === 0) {
      listInst.addClass('nodata')
    }
    
  } 
  const onClear = () => {
    reset({search: ''})
    setIsIcon(false)
  }
  const onChange = (e) => {
    const vals = e.target.value
    setIsIcon(false)
    if (vals) {
      setIsIcon(true)
    }
  }
  const onkeydown = (e) => {
    if (e.keyCode === 13) {
      setValue('search', e.target.value)
      // console.log(e, 'handleSubmit', handleSubmit);
    }
  }
  return (
    <form className="pages-search-wrap"  onSubmit={handleSubmit(onSubmit)}>
      <input autoComplete="off" placeholder="搜索工作岗位" className="ss-input"
        {...register('search')}
        onChange={onChange}
        onKeyDown={onkeydown}
       />
       {isIcon ? <i className='icon-clear' onClick={onClear}></i> : ''}
       <button type='submit' className='ss-button btn-default'><i className='icon-search'></i>搜索</button>
    </form>
  );
}

const Pages = props => {
  return (
    <div className="pages-tab-content">
      <div className="wid1200">
        <div className="pages-title mb-default">招聘岗位</div>
        <SearchForm />
        {/* <div className="pages-search-wrap">
          <input type="text" re placeholder="搜索工作岗位" className="ss-input" />
          <button className="ss-button btn-default" onClick={searchSubmit}><i className="icon-search"></i>搜索</button>
        </div> */}
        <List {...searchTypeListCfg} />
        <List {...ListCfg} />
      </div>
    </div>
  )
}


export default Pages